import { getLocale } from '../utils';
import { Domains, Locale, LocaleShorthand, SiteName } from './locale';

const locale = getLocale();

const webInventory = {
    [Locale['en-CA']]: 'ps_ca_web_inv',
    [Locale['en-US']]: 'ps_us_web_inv',
};

const currencyCode = {
    [Locale['en-CA']]: 'CAD',
    [Locale['en-US']]: 'USD',
};

const hostname = {
    [Locale['en-CA']]: Domains['en-CA'],
    [Locale['en-US']]: Domains['en-US'],
};

const staticPostalCode = {
    // CA is switching to nationwide inventory, but still requires a set postal code for checkout.
    [Locale['en-CA']]: 'A1A 1A1',

    // USA shouldn't need it, but I am adding it to avoid any potential issues.
    [Locale['en-US']]: '98281',
};

export const LOCALIZED = {
    currencyCode: currencyCode[getLocale()],
    hostname: hostname[getLocale()],
    localeSFCC: SiteName[locale],
    localeShorthand: LocaleShorthand[locale],
    staticPostalCode: staticPostalCode[getLocale()],
    webInventory: webInventory[getLocale()],
};

export const getWebInventory = (locale: Locale | 'en-US' | 'en-CA'): string => webInventory[locale];
